import $ from "jquery";
import "./styles/app.css";
import { resolveRoute, navigate } from "./router.js";
import { homeView, stopHomeCycle } from "./views/home.js";
import { liveView, stopLiveRefresh } from "./views/live.js";
import { championshipsView } from "./views/championships.js";
import { calendarView } from "./views/calendar.js";
import { standingsView } from "./views/standings.js";
import { r2CompareView } from "./views/r2-compare.js";
import { shell, pageHeading, statusPanel } from "./components.js";
import { setSelectedCommittee } from "./utils.js";

window.$ = window.jQuery = $;
let activeController;

async function render() {
  activeController?.abort();
  stopHomeCycle();
  stopLiveRefresh();
  activeController = new AbortController();
  const route = resolveRoute();
  if (!["r2Compare", "r2CompareStandings"].includes(route.name)) document.querySelector('meta[name="robots"][data-r2-diagnostic="true"]')?.remove();
  window.scrollTo({ top: 0, behavior: "instant" });
  try {
    if (route.name === "home") await homeView(activeController.signal);
    else if (route.name === "live") await liveView(activeController.signal);
    else if (route.name === "championships") await championshipsView(route.params, activeController.signal);
    else if (route.name === "calendar") await calendarView(route.params, activeController.signal);
    else if (route.name === "standings") await standingsView(route.params, activeController.signal);
    else if (route.name === "r2Compare") await r2CompareView(route.params, activeController.signal);
    else if (route.name === "r2CompareStandings") await r2CompareView({ ...route.params, section: "tables" }, activeController.signal);
    else {
      document.title = "Pagina non trovata | FIPAV Online";
      document.querySelector("#app").innerHTML = shell(pageHeading("Pagina non trovata") + statusPanel("L'indirizzo richiesto non esiste.", "error") + '<div class="container"><a class="button" href="/" data-link>Torna alla home</a></div>');
    }
  } catch (error) {
    if (error.name !== "AbortError") throw error;
  }
}

document.addEventListener("click", (event) => {
  const posterButton = event.target.closest("[data-poster-url]");
  if (posterButton) {
    const dialog = document.querySelector("#poster-dialog");
    const image = document.querySelector("#poster-image");
    if (!dialog || !image) return;
    const title = posterButton.dataset.posterTitle || "Locandina gara";
    document.querySelector("#poster-dialog-title").textContent = title;
    const posterError = document.querySelector("#poster-error");
    posterError.hidden = true;
    image.hidden = false;
    image.alt = `Locandina ${title}`;
    image.onerror = () => { image.hidden = true; posterError.hidden = false; };
    image.src = posterButton.dataset.posterUrl;
    document.querySelector("#poster-open").href = image.src;
    dialog.showModal();
    return;
  }
  if (event.target.closest(".poster-close")) {
    document.querySelector("#poster-dialog")?.close();
    return;
  }
  const escoreButton = event.target.closest("[data-escore-match]");
  if (escoreButton) {
    const dialog = document.querySelector("#escore-dialog");
    const frame = document.querySelector("#escore-dialog-frame");
    if (dialog && frame) {
      document.querySelector("#escore-dialog-title").textContent = escoreButton.dataset.escoreTitle || "eScoreVolley";
      document.querySelector("#escore-dialog-stadium").textContent = escoreButton.dataset.escoreStadium || "";
      frame.src = `https://escore.fipavonline.it?gara=${encodeURIComponent(escoreButton.dataset.escoreMatch)}`;
      dialog.showModal();
    }
    return;
  }
  if (event.target.closest(".escore-dialog-close")) {
    document.querySelector("#escore-dialog")?.close();
    return;
  }
  const committeeLink = event.target.closest("[data-committee]");
  if (committeeLink) setSelectedCommittee(committeeLink.dataset.committee);
  const link = event.target.closest("a[data-link]");
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  navigate(link.href);
});

document.addEventListener("close", (event) => {
  if (event.target.id === "escore-dialog") {
    const frame = document.querySelector("#escore-dialog-frame");
    if (frame) frame.src = "about:blank";
  }
}, true);

document.addEventListener("click", (event) => {
  const toggle = event.target.closest(".nav-toggle");
  if (!toggle) return;
  const open = toggle.getAttribute("aria-expanded") !== "true";
  toggle.setAttribute("aria-expanded", String(open));
  document.querySelector("#main-nav")?.classList.toggle("open", open);
});

window.addEventListener("popstate", render);
render();
